<span> 1 : {{ mapScale() }} </span>
